export default __webpack_public_path__ + "static/media/acc.eb918612.svg";